import { useEffect } from "react";
import seo from "@content/seo.json";

/**
 * Runtime SEO helper.
 * The initial <title>, description and OG tags are already baked into
 * public/index.html (so crawlers see them without JS). This component
 * updates them when the SPA route changes (e.g. /thank-you).
 *
 * Usage:
 *   <SEO title="Thank You" description="..." path="/thank-you" />
 */
const setMeta = (selector, value) => {
    if (!value) return;
    let el = document.querySelector(selector);
    if (!el) return;
    if (el.hasAttribute("content")) el.setAttribute("content", value);
    else el.textContent = value;
};

const SEO = ({ title, description, path = "/" }) => {
    useEffect(() => {
        const fullTitle = title
            ? `${title} | ${seo.author || "Grads2Pro"}`
            : seo.title;
        const fullDesc = description || seo.description;
        const url = `${(seo.siteUrl || "").replace(/\/$/, "")}${path}`;

        document.title = fullTitle;

        setMeta('meta[name="description"]', fullDesc);
        setMeta('meta[property="og:title"]', fullTitle);
        setMeta('meta[property="og:description"]', fullDesc);
        setMeta('meta[property="og:url"]', url);
        setMeta('meta[name="twitter:title"]', fullTitle);
        setMeta('meta[name="twitter:description"]', fullDesc);

        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.setAttribute("href", url);
    }, [title, description, path]);

    return null;
};

export default SEO;
